// Chakra imports
import {
  Flex,
  Box,
  Icon,
  Select,
  Text,
  useColorModeValue,
  IconButton,
  useDisclosure,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import LineChart from 'components/charts/LineChart';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';

// Custom components
import Card from 'components/card/Card';
import {
  lineChartDataOverallRevenue,
  lineChartOptionsOverallRevenue,
} from 'variables/charts';
import { MdDownload, MdOutlineFavoriteBorder } from 'react-icons/md';
import Chart from "react-apexcharts";
//import DashboardsSmartHome from 'views/admin/dashboards/smartHome'
import CasillasGrafico from 'views/admin/dashboards/default/components/CasillasGrafico';

// Assets
import { RiArrowUpSFill } from 'react-icons/ri';
import { useEffect, useRef, useState } from 'react';
import { type } from 'os';
import Invoice from 'views/admin/main/account/invoice';
import React from 'react';

export default function OverallRevenue(props: { [x: string]: any }) {
  const { ...rest } = props;
  //let options =

  const [seccionx, setseccionx] = useState();

  const [cate, setcate] = useState([1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]);
  const [total, settotal] = useState();
  const [catex, setcatex] = useState(['1991', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999']);
  const Grafico = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure()


  function seteo_seccion(x: any){
    //  alert(x)
      
  }


  const [optionsx, setoptionsx] = useState({
    labels: catex,
    chart: {
      events: {
        click: (event: any, chartContext: { w: { config: { labels: { [x: string]: any; }; }; }; }, config: { dataPointIndex: string | number; }) => {
        //  alert(chartContext.w.config.labels[config.dataPointIndex])
        //seteo_seccion(chartContext.w.config.labels[config.dataPointIndex]);
        alert('2')
        }
      }
    }


  })
  const [options, setoptions] = useState(
    {

      xaxis: {
        categories: cate
      },
      events: {
        selection: () => {
          alert('asdad')
        }
      }



      // events: {
      //   selection: ()=>{
      //     alert('asda');
      //   }
      // }

    }
  )
  //eslint-disable-next-line
  const [Line, setLine] = useState([
    {
      name: 'Promovidos',
      data: [200, 64, 48, 66, 49, 68]
    },
    {
      name: 'Votos Confirmados',
      data: [10, 40, 24, 46, 20, 46]
    }
  ]);

  const sendRandomData = async () => {
    const currentDate = new Date();
    const randNumber = Math.floor(Math.random() * 100);
    const showDate = moment(currentDate).format('HH:mm:ss');
    const doc = {
      time: showDate,
      bid: randNumber,
    }

    let datos = await fetch(process.env.REACT_APP_URL_SERVER + '/votos', {
      method: 'GET',
      //  body: JSON.stringify(doc),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })

    const result = await datos.json();
   // const [seccion, setseccion] = useState();

    //console.log(result.new_array)
    setcate(result.seccionesx)
    setoptionsx({
      labels:
        result.seccionesx
      , chart: {
        events: {
          click: (event: any, chartContext: { w: { config: { labels: { [x: string]: any; }; }; }; }, config: { dataPointIndex: string | number; }) => {
          // seteo_seccion(chartContext.w.config.labels[config.dataPointIndex]);
            // alert('1')
            // alert('2')
            let x = (chartContext.w.config.labels[config.dataPointIndex])
            setseccionx(x.split(':')[1])
            //setseccionx(chartContext.w.config.labels[config.dataPointIndex])

           onOpen();
          }
        }
      }
    })
    setLine(result.votosx)

    let datosX = await fetch(process.env.REACT_APP_URL_SERVER + '/votos_confirmados', {
      method: 'GET',
      //  body: JSON.stringify(doc),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })

    setcate(result.seccionesx)

    const resultX = await datosX.json();
    settotal(resultX.Total);
    //console.log(result.new_array)


  }
  const newOptions = {
    ...lineChartOptionsOverallRevenue,
    colors: ['var(--chakra-colors-brand-500)', '#39B8FF'],

  };

  const ApexChart = (data: any) => {
    return (
      <div>
        <Chart
          type="area"
          height={300}
          width='100%'
          series={[
            {
              name: "Commits",
              data: data?.map((data: { bid: any; }) => data.bid)
            }
          ]}

          options={{
            chart: {
              toolbar: {
                show: false
              },

            },
            colors: ['#f90000'],
            stroke: { width: 1, curve: 'smooth' },
            dataLabels: { enabled: false },
            xaxis: {
              categories: data?.map((data: { time: any; }) => data.time),

            },
            yaxis: {
              show: false,
            }
          }}
        />
      </div>
    )
  }
  // Chakra Color Mode
  useEffect(() => {
    const timer2 = setInterval(() => { sendRandomData() }, 6000);
    return () => { clearInterval(timer2) }
  }, [])
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  //const [orden, setOrden] = React.useState(0);

  return (
  
  
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb={{ base: '20px', lg: '0px' }}
      {...rest}
    >
      <Flex justify="space-between" px="20px" pt="5px" w="100%">
        <Flex align="center" w="100%">
          <Flex flexDirection="column" me="20px">
            <Text
              color={textColor}
              fontSize="21px"
              fontWeight="700"
              lineHeight="100%"
            >
              Votos Confirmados: { total}
              {/* # ESTE APARTADO REFLEJARA NUMERO DE VOTOS POR CONTENDIENTE */}
            </Text>
            {/* <Text
              color="secondaryGray.600"
              fontSize="sm"
              fontWeight="500"
              mt="4px"
            >
              Incremento un:
            </Text> */}
          </Flex>
          {/* <Flex align="center">
            <Icon as={RiArrowUpSFill} color="green.500" me="2px" />
            <Text color="green.500" fontSize="sm" fontWeight="700">
              +2.45%
            </Text>
          </Flex> */}
        </Flex>
        {/* <Select
          fontSize="sm"
          variant="subtle"
          defaultValue="monthly"
          width="unset"
          fontWeight="700"
        >
          <option value="daily">Diario</option>
          <option value="monthly">Mensual</option>
          <option value="yearly">Anual</option>
        </Select> */}

        <IconButton aria-label="1" me='2px' px='0px' variant='no-hover' bg='transparent' onClick={() => {

          setLine([
            {
              name: 'Promovidos',
              data: [80, 44, 88, 26, 49, 68]
            },
            {
              name: 'Votos Confirmados',
              data: [19, 20, 94, 96, 20, 46]
            }
          ])
          alert('EMPIEZA DESCARGA')
        }}>
          <Icon as={MdDownload} h='24px' w='24px' color='blue.300' />
        </IconButton>

        <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>#Seccion: {seccionx} </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
      <CasillasGrafico id={seccionx}></CasillasGrafico>

        {/* <Invoice id={orden}></Invoice> */}
      </ModalBody>
      <ModalFooter>
        <Button colorScheme='red' mr={3} onClick={onClose}>
          Cerrar
        </Button>
     
      </ModalFooter>
    </ModalContent>
  </Modal>
      </Flex>
      <Box minH="260px" mt="auto" w="100%">
        <Chart
          options={optionsx}
          series={Line}
          type="bar"
        />
      </Box>
    </Card>
  );
}
